import { z } from "zod";

const FeesSchema = z.array(
  z.object({
    type: z.enum(["price", "percent"]),
    label: z.enum(["wage", "cost"]),
    value: z.number(),
    amount: z.number(),
    isCreditor: z.boolean(),
    accountTypeId: z.number(),
  })
);

export const MaterialSchema = z.object({
  productId: z.number(),
  date: z.string(),
  formulaId: z.number(),
  quantity: z.number(),
  quantityUnit: z.string(),
  materialsRows: z.array(
    z.object({
      ind: z.string(),
      ProductId: z.number(),
      quantity: z.number(),
      selectedUnit: z.string(),
      unitPrice: z.number(),
      totalPrice: z.number(),
      warehouseId: z.number(),
    })
  ),
  tableTotalPrice: z.number(),
 // optionableType: z.enum(["financial", "person"]),
 // optionableId: z.number(),
  automaticRemmitance: z.boolean(),
  costs: FeesSchema,
  wages: FeesSchema,
});
